<template>
  <div class="box">
    <div class="box_content">
      <div class="tabbar">
        <div v-for="(item, index) in tabList" :key="index" @click="changeTab(index, item)"
             :class="tab === item.path ? 'onbar' : 'bar'">
          <div class="popup_box">
            <span>{{ item.label }}</span>
          </div>
        </div>
      </div>
      <div class="login" v-if="show_login_info && !hasToken" style="cursor: pointer;">
        <div @click="start_login">登录/注册</div>
      </div>
      <div :class="tab === 8 ? 'onbar login' : 'bar login'" v-if="hasToken" style="cursor: pointer;">
        <el-icon size="24" shape="circle" @click="go_personal">
          <Avatar/>
        </el-icon>
        <span @click="go_personal">{{ userName }}</span>
        <span>丨</span>
        <div @click="logout">退出</div>
        <!-- <div @click="logout">
           <img src="../../assets/layout/dropDown.png" alt="">
        </div> -->
      </div>
    </div>
<!--    <Login :loginDialog="loginDialog" :can_send_code="can_send_code" @change_province="change_province"-->
<!--           @bind_phone="show_bind_phone" @add_base_info="add_baseInfo_fun" @show_huadong_fun="show_huadong_fun"/>-->
<!--    <bind_phone :show_bind_phone_status="show_bind_phone_status" @change_user_phone="change_user_phone"-->
<!--                @add_base_info="add_baseInfo_fun"></bind_phone>-->
    <!--        <user_score :clear="true"  :msgDialog="msgDialog"></user_score>-->
    <el-dialog
        v-model="show_user_change_times_status"
        width="600px"
        class="class-dialog"
        :show-header="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="close_dialog"
    >
      <div class="content_bg">
        <div class="top">
          <div class="name"><span style="color:#e93a29;">提醒</span></div>
          <div class="progress" style="margin-top: 20px;font-size: 14px;margin-left: 45px;">
            <div>
              当年数据已更新，请重新录入高考分数
            </div>
          </div>
        </div>
        <div class="bottom">
          <div class="ms-button" @click="do_set_score_info">好的</div>
        </div>
      </div>
    </el-dialog>
    <teacher-login-alert v-if="showTeacherLogin"></teacher-login-alert>
  </div>
</template>

<script>
import {ElMessageBox} from "element-plus";
import Check_huadong from "@/layout/comps/check_huadong.vue";
import {useInfoStore} from "@/store";
import TeacherLoginAlert from "@/views/subject/conps/teacherLoginAlert.vue";
import {getShowAiStatus, isTeacher, spliceStrings} from "@/utils/publicMethonds.js";

export default {
  components: {
    TeacherLoginAlert,
    Check_huadong,
  },
  props: {
    show_login: {
      type: Number,
      default: 0
    },
    add_base_info: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      showTeacherLogin: false,
      show_login_info: true,
      show_user_change_times_status: false,
      show_bind_phone_status: false,
      in_user_change_times_status: false,
      show_check_huadong: 0,
      can_send_code: 0,
      tab: '/home',
      province_url_list: [],
      show_ai_btn: false,
      version: 24,
    };
  },
  watch: {
    show_bind_phone(num) {
      if (num > 0) {
        this.show_bind_phone_status = true
      }
    },
    '$route'(to, from) {
      this.tab = to.meta?.tabCard || to.path
    }
  },
  computed: {
    baseInfo() {
      return useInfoStore().baseInfo
    },
    hasToken() {
      return Object.keys(this.userBaseInfo).length > 3
    },
    userName() {
      return spliceStrings(this.userBaseInfo.name, 5)
    },
    tabList() {
      const arr = [
        {
          label: "首页",
          path: "/home",
        },
        {
          label: "高一选科",
          path: "/subject_analysis",
        },
        {
          label: "高考工具箱",
          path: "/tools",
        },

        {
          label: "测评",
          path: "/assess_info",
        },
        {
          label: "AI报志愿",
          path: "/ai_list",
        },
        {
          label: "提前批",
          path: "/preBatch",
        },
        {
          label: "志愿填报",
          path: "/chose_batch",
        },
        {
          label: "我的志愿",
          path: "/intention",
        }
      ]
      const teacher = isTeacher()
      arr[4].label = teacher ? 'AI报志愿' : '智能选专业'
      return arr
    }
  },

  updated() {
    if (isTeacher()) {
      this.show_login_info = false
    }
    if (isTeacher()) {
      this.show_ai_btn = true
    }
  },
  created() {
    this.tab = this.$route?.meta?.tabCard||this.$route.path
    const userInfo = useInfoStore()
    userInfo.setKey('showTeacherLogin', false)
    if (isTeacher()) {
      this.show_ai_btn = true
    }
    if (isTeacher()) {
      this.show_login_info = false
    }
    const agentId = this.getGlobalDomainData('domain')
    let favicon = document.querySelector('link[rel="icon"]');
    if (favicon !== null) {
      favicon.href = 'https://oss.shudaozaixian.com/cache/favicon/' + agentId + '.ico';
    } else {
      favicon = document.createElement("link");
      favicon.rel = "icon";
      favicon.href = 'https://oss.shudaozaixian.com/cache/favicon/' + agentId + '.ico';
      document.head.appendChild(favicon);
    }
    this.check_version()
    this.getGlobalProvinceData().then(res => {
      this.province_url_list = res
      localStorage.setItem('province_url_list', JSON.stringify(this.province_url_list))
    })
  },
  mounted() {
    useInfoStore().$subscribe((args, state) => {
      this.showTeacherLogin = state.showTeacherLogin
    })
  },
  methods: {
    do_set_score_info() {
      this.show_user_change_times_status = false
      this.$router.push('/home')
    },
    close_dialog() {
    },
    check_version() {
      const currentV = Number(localStorage.getItem('currentV'))
      if (currentV > this.version) {
        location.reload(true)
      }
    },
    start_login() {
      let chose_province_id = localStorage.getItem('chose_province_id')
      let chose_province_name = localStorage.getItem('chose_province_name')
      localStorage.setItem('chose_province_id', chose_province_id)
      localStorage.setItem('chose_province_name', chose_province_name)
      this.$router.push('/login')
    },
    check_huadong_success() {
      this.can_send_code += 1
    },
    change_user_phone() {
      localStorage.setItem('showCode', 1)
      this.$router.push({path: '/personal'})
    },
    show_bind_phone() {
      this.show_bind_phone_status = true
    },
    change_province(info) {
      this.$emit('change_province')
    },
    go_personal() {
      this.$router.push({path: '/personal'})
    },
    logout() {
      const provinceId = localStorage.getItem('provinceId')
      this.clearBaseInfo()
      this.$emit('change_province')
      const strUrl = localStorage.getItem('localUrl')
      localStorage.clear()
      sessionStorage.removeItem('showAdPop')
      if (strUrl) {
        localStorage.setItem('localUrl', strUrl)
      }
      if (provinceId) {
        localStorage.setItem('provinceIdBeforeOut', provinceId)
      }
      if (isTeacher()) {
        setTimeout(() => {
          window.parent.close()
        }, 200)
      }
      this.$router.push({path: '/home'})
      setTimeout(() => {
        window.location.reload()
      }, 200)
    },
    changeTab(index, item = {}) {

      let path = item.path

      if (path === 'chose_batch') {
        let baseInfo = localStorage.getItem('baseInfo') || ''
        if (baseInfo !== null && baseInfo !== 'null' && baseInfo !== '[]' && baseInfo !== '' && baseInfo !== 'undefined') {
          if (baseInfo.subject_one < 1 || baseInfo.subject_three < 1 || baseInfo.subject_two < 1 || baseInfo.score < 1 || baseInfo.precedence < 1) {
            ElMessageBox.alert('请填写选科及分数信息', '提醒', {
              confirmButtonClass: 'confirm_button_class',
              confirmButtonText: '好的',
              callback: () => {
                this.$router.push({path: '/'})
              },
            })
          }
        }
        this.$router.push({path: '/chose_batch'})
      } else {
        this.$router.push({path});
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/var.scss";

.box {
  //width: calc(100% - $width-pdTotal);
  width: 1230px;
  height: 40px;
  line-height: 40px;
  margin: 0 auto;
  border-bottom: 2px solid #ff5410;

  .box_content {
    width: 1230px;
    height: 40px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 18px;
    color: var(--font-1);

    .tabbar {
      flex: 1;
      padding-right: 28px;
      box-sizing: border-box;
    }

    .tabbar,
    .login {
      display: flex;
      align-items: center;
      height: 100%;
      font-family: 'MyCustomFont', sans-serif;


      .onbar,
      .bar {
        flex: 1;
        font-size: 18px;
        cursor: pointer;
        //border-bottom: 2px solid transparent;
        //   padding: 0 20px 0 0;
        text-align: center;
        box-sizing: border-box;
        width: 130px;
        height: 40px;
      }

      .onbar {
        color: #fff;
        font-weight: 700;
        background: #ff6600;
        border-radius: 4px 4px 0 0;
        width: 130px;
        height: 40px;
      }

      .bar:hover {
        color: #FF6600;
      }
    }

    .login {
      color: var(--font-3);

      div {
        cursor: pointer;

        &:hover {
          color: var(--primary);
        }
      }

      span {
        // margin: 0 10px;
      }
    }
  }
}

.popup_box {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  position: relative;
}


.content_bg {
  width: 100%;
  height: 300px;
  color: var(--font-1);
  display: flex;
  flex-direction: column;
  align-items: center;

  .top {
    width: 600px;
    margin-top: 50px;

    .name {
      width: 100%;
      text-align: center;
      font-size: 24px;
      font-weight: 700;
    }

    .progress {
      width: 100%;
      margin-top: 50px;

      .font {
        color: var(--font-2);
        font-size: 14px;
        margin: 10px;
      }
    }
  }

  .center {
    width: 600px;
    color: var(--font-1);
    margin-top: 40px;
    margin-bottom: 70px;

    .topic {
      font-size: 18px;
      font-weight: 500;
      margin-bottom: 20px;
    }

    .answer {
      display: flex;

      div {
        width: 300px;
        height: 40px;
        line-height: 40px;
        background: var(--main-bg);
        border-radius: 6px;
        font-size: 16px;
        cursor: pointer;

        &:nth-of-type(2) {
          margin-right: 0;
        }
      }

      div:hover {
        background-color: #E93A29;
        color: white;
      }
    }
  }

  .bottom {
    display: flex;
    justify-content: center;

    .ms-button {
      margin-top: 100px;
      bottom: 20px;
      width: 120px;
      height: 36px;
      text-align: center;
      line-height: 36px;
      font-size: 18px;
    }
  }
}

.confirm_button_class {
  background-color: #E93A29 !important;
  border: 1px #E93A29 solid !important;
  color: white !important;
}
</style>
